// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"124":"64c016b23842274ace05","256":"403f560827cd380cf454","742":"0800daa3683bfd959568","772":"04659f4e17b2be2d9c6c","803":"42b15ee449e894c15e88"}[chunkId] + ".js";
};